<script>
import { backUrl, mapboxPublicKey } from '@src/config.js'
import { useIndexStore } from '@src/store'
import axios from 'axios'

export default {
  name: 'NewProject',
  data () {
    return {
      newProjectName: null,
      newAddress: null,
      addressAutocomplete: [],
      showDialog: false,
    }
  },
  computed: {
    store () {
      return useIndexStore()
    },
    addressCenter () {
      const addressFound = this.addressAutocomplete.find(address => address.place_name === this.newAddress)
      return addressFound ? addressFound.center : null
    },
  },
  methods: {
    async autocomplete (event) {
      this.newAddress = event.target.value
      if (this.newAddress && this.newAddress.length > 3) {
        // eslint-disable-next-line max-len
        const response = await axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(this.newAddress)}.json?access_token=${mapboxPublicKey}&autocomplete=true`)
        this.addressAutocomplete = response.data.features
      }
    },
    closeDialog () {
      this.showDialog = false
    },
    addNewProject () {
      this.newProjectName = null,
      this.newAddress = null,
      this.showDialog = true
    },
    async createProject () {
      if (!this.newProjectName) {
        this.store.changeNotification({
          text: this.$gettext('Please enter a project name'),
          autoClose: true,
          type: 'warning',
        })
        return
      }
      try {
        const response = await axios.post(`${backUrl}projects`, {
          name: this.newProjectName,
          authorID: this.store.user.id,
          addressCenter: this.addressCenter ?? [],
        })
        this.store.changeProject({
          ...response.data,
        })
        this.store.changeNotification({
          text: this.$gettext('New project successfully created'),
          autoClose: true,
          type: 'positive',
        })
      } catch (error) {
        console.error(error)
        this.store.changeNotification({
          text: this.$gettext('An error occurred while creating the project'),
          autoClose: false,
          type: 'error',
        })
      } finally {
        this.showDialog = false
      }
    },
  },
}
</script>
<template>
  <v-btn
    prepend-icon="fas fa-plus"
    variant="elevated"
    color="primary"
    :text="$gettext('New Project')"
    @click="addNewProject"
  />
  <v-dialog
    v-model="showDialog"
    width="25%"
    persistent
  >
    <v-card>
      <v-card-text>
        <v-text-field
          v-model="newProjectName"
          :label="$gettext('Project name')"
        />
        <v-autocomplete
          v-model="newAddress"
          :label="$gettext('Address (optional)')"
          :items="addressAutocomplete"
          item-title="place_name"
          @keydown="autocomplete"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn
          size="small"
          color="secondary"
          variant="elevated"
          :text="$gettext('Cancel')"
          @click="closeDialog"
        />
        <v-btn
          size="small"
          color="primary"
          variant="elevated"
          :text="$gettext('Confirm creation')"
          @click="createProject"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style>
.v-card {
  overflow-y: hidden !important;
}
.v-card-text {
  overflow-y: auto;
}
</style>
